import { GameStateEnums } from '../../../../../../shared/GameEnums.ts';
import { BeginnerModeConstants, HiddenUIElement, getWaitMSForAction } from '@colonist/game-beginner-mode';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameBeginnerModeCardsHelper {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.BeginnerModeActionUpdated:
                this.onBeginnerModeActionUpdate(data);
                break;
            case UIGameEventEnums.GivePlayerCardFromTile:
                this._areCardsBeingDealt = true;
                break;
            case UIGameEventEnums.CardAnimationEnd:
                this._areCardsBeingDealt = false;
                break;
            default:
                break;
        }
    }
    get shouldCardsFlyToRobber() {
        return this._shouldCardsFlyToRobber;
    }
    get cardFlyAnimationWaitMS() {
        return this._cardFlyAnimationWaitMS;
    }
    get areCardsBeingDealt() {
        return this._areCardsBeingDealt;
    }
    onBeginnerModeActionUpdate(data) {
        const isBankHidden = data.hiddenUIElements.includes(HiddenUIElement.Bank);
        this._shouldCardsFlyToRobber = isBankHidden;
        this._cardFlyAnimationWaitMS = getWaitMSForAction(BeginnerModeConstants.BASE_WAIT_MS_FOR_CARD_FLY_ANIMATION, data.actionIndex);
    }
    addPendingCardsToMyCurrentCardEnums(myCurrentCardEnums, cardsToBeAddedFromTile) {
        const myColor = this.uiGameManager.gameController.myColor;
        for (const transaction of cardsToBeAddedFromTile){
            if (transaction.owner != myColor) continue;
            myCurrentCardEnums.push(transaction.card);
        }
        myCurrentCardEnums.sort();
    }
    constructor(uiGameManager){
        this._shouldCardsFlyToRobber = false;
        this._cardFlyAnimationWaitMS = 500;
        this._areCardsBeingDealt = false;
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
    }
}
